export default {
  namespaced: true,
  state: {
    tabIndex: 0
  },
  mutations: {
    setTabIndex(state, index) {
      state.tabIndex = index;
    }
  }
};
